import { ContextMenu } from "radix-ui";
import { PROJECT_MODAL_LIST_COLOR } from "../../../constants";
import { SpaceColorCircle } from "../../ProjectFilter/SideBarMenu/SpaceColorCircle";
import clsx from "clsx";

// ContextMenu Content Component
interface ContextMenuContentProps
  extends React.ComponentPropsWithoutRef<typeof ContextMenu.Content> {
  children: React.ReactNode;
  className?: string;
}

const Content = ({ children, className = "", ...props }: ContextMenuContentProps) => {
  return (
    <ContextMenu.Content
      className={clsx(
        className,
        "z-[10] flex h-fit min-w-[120px] max-w-[190px] flex-col items-center justify-center overflow-hidden rounded-[6px] border border-solid border-25 bg-20"
      )}
      {...props}
    >
      {children}
    </ContextMenu.Content>
  );
};

// Color Picker Section
interface ContextMenuColorPickerProps {
  spaceColor: string;
  onChangeSpaceColor: (color: string) => void;
}

const ColorPicker = ({ spaceColor, onChangeSpaceColor }: ContextMenuColorPickerProps) => {
  return (
    <>
      <ContextMenu.RadioGroup
        className="flex flex-wrap gap-2 p-2.5"
        value={spaceColor}
        onValueChange={onChangeSpaceColor}
      >
        {PROJECT_MODAL_LIST_COLOR.map((color) => {
          const colorValue = color.toLowerCase();

          return (
            <ContextMenu.RadioItem
              key={colorValue}
              value={colorValue}
              className="cursor-pointer outline-none"
            >
              <SpaceColorCircle
                key={colorValue}
                colorValue={colorValue}
                spaceColor={spaceColor}
              />
            </ContextMenu.RadioItem>
          );
        })}
      </ContextMenu.RadioGroup>
      <ContextMenu.Separator className="m-0 h-px w-full border-none bg-[rgba(255,255,255,0.08)]" />
    </>
  );
};

// Menu Item Component
interface ContextMenuItemProps extends React.ComponentPropsWithoutRef<typeof ContextMenu.Item> {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
}

const Item = ({ children, onClick, className, ...props }: ContextMenuItemProps) => {
  return (
    <ContextMenu.Item
      className={clsx(
        className,
        "box-border w-full cursor-pointer border-none p-[8px] text-left text-xs font-normal text-white outline-none hover:bg-[rgba(255,255,255,0.08)]"
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </ContextMenu.Item>
  );
};

export const ContextMenuContent = Object.assign(Content, {
  ColorPicker,
  Item,
});
